import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Link from '@/components/redesign/JourneyLink';
import { getRedirectTarget } from '@/components/RedirectHandler';
import applyPageMetadata from '@/components/seo/pageMetadata';
export default function PageNotFound({ embedded = false }) {
  const { pathname, search, hash } = useLocation();
  const target = getRedirectTarget(pathname);
  const en = pathname.toLowerCase().startsWith('/en/');
  useEffect(() => {
    if (target) return;
    applyPageMetadata({ title: `${en ? 'Page not found' : 'Siden blev ikke fundet'} | enkel energi`, description: en ? 'This page does not exist. Find electricity agreements, EV chargers and customer support at enkel energi.' : 'Siden findes ikke. Find elaftaler, ladebokse og hjælp til kunder hos enkel energi.', path: pathname });
    const robots = document.createElement('meta');
    robots.name = 'robots'; robots.content = 'noindex, follow';
    document.head.appendChild(robots);
    const meta = document.createElement('meta');
    meta.name = 'prerender-status-code'; meta.content = '404';
    document.head.appendChild(meta);
    return () => { meta.remove(); robots.remove(); };
  }, [target, pathname]);
  if (target) {
    const [path, anchor] = target.split('#');
    return <Navigate replace to={{ pathname: path, search, hash: anchor ? `#${anchor}` : hash }} />;
  }
  const Container = embedded ? 'section' : 'main';
  return <Container className="ee-site min-h-screen flex items-center justify-center bg-ee-canvas text-ee-ink px-6">
    <div className="max-w-lg space-y-6"><p className="ee-eyebrow">404</p>
      <h1 className="text-4xl">{en ? 'This page could not be found.' : 'Vi kunne ikke finde siden.'}</h1>
      <p className="text-ee-muted leading-7">{en ? 'The link may be outdated. You can return to the homepage or continue choosing your electricity agreement.' : 'Linket kan være forældet. Du kan vende tilbage til forsiden eller fortsætte med at vælge din elaftale.'}</p>
      <nav className="flex flex-wrap gap-5" aria-label={en ? 'Find your way' : 'Find videre'}>
        <Link className="ee-button" to={en ? '/en/electricity-deal' : '/elaftale'}>{en ? 'Choose electricity agreement' : 'Vælg elaftale'}</Link>
        <Link className="ee-text-link" to={en ? '/en' : '/'}>{en ? 'Go to homepage' : 'Gå til forsiden'}</Link>
      </nav>
    </div>
  </Container>;
}